import React from 'react'

import IMessage from '../../models/Message'

interface MessageProps {
  message: IMessage;
}

const Message: React.FC<MessageProps> = ({ message }) => (
  <div className='ch-c-message' data-testid='message-preview'>
    <div className='ch-c-message__header'><span>{message.date}</span><span>{message.category}</span></div>
    {message.read ? message.subject : <strong>{message.subject}</strong>}
  </div>
)

export interface MessageListProps {
  header: React.ReactNode;
  headerAction?: React.ReactNode;
  messages: IMessage[];
  emptyText: string;
}

export const MessageList: React.FC<MessageListProps> = ({ header, headerAction, messages, emptyText }) => (
  <div>
    <header className='ch-c-message-list__header'>
      {header}{headerAction}
    </header>
    <>
      {messages.length
        ? messages.map(message => <Message message={message} key={message.id} />)
        : <div className='ch-c-message__empty-text'>{emptyText}</div>}
    </>
  </div>
)
